import BaseComponent    from "./BaseComponent";
import App              from "../Core/App";
import LayoutHelper     from "../Helper/Layout";
import AnimationHelper  from "../Helper/Animation";

export default class NavComponent extends BaseComponent {
    constructor() {
        super();

        this._bindListener( 'click', this._onToggle, '.blb-nav-toggle-btn' );
    }

    _onToggle( event ) {
        let box = App.getInstance().getComponent('box'),
            delay = 0;

        $('.blb-nav-toggle-btn').toggleClass('active');

        // Collapse subnav in mobile view before expanding main nav
        if( LayoutHelper.getCurrentLayout() == 'mobile' && $('#blb-subnav').hasClass('sticky') && !$('#blb-subnav').hasClass('collapsed') ) {
            // ToDo: remove this hotfix, eg. move the box animation conditions somewhere else.
            app.getComponent('box')._onToggleClick({target: $('#blb-subnav-toggle-btn')[0]});
        }

        AnimationHelper.toggle( $('.blb-nav-wrapper'), 'hidden' );
    }

    _onResize() {
        if( LayoutHelper.getCurrentLayout() != 'mobile' ) {
            // Collapse all menus expanded in mobile view
            $('ul.menu-item-list.header-menu > li.menu-item.has-sub-menu').each((i,el) => {
                // Preserve highlighting on current top page
                if( !$(el).hasClass('current') ) $(el).removeClass('active');
                else $(el).addClass('active');
            });
        }
    }
}